import React from "react";

// This is a minimal representation to make the refactoring work.
const LazyImage = ({ src, alt, className, style, fetchpriority, ...props }) => {
  // A real LazyImage component would use IntersectionObserver or similar logic
  // to load the image only when it enters the viewport.
  // For this refactoring, we'll just render the img tag.
  return (
    <img src={src} alt={alt} className={className} style={style} {...props} />
  );
};

export default LazyImage;
